<template>
  <div class="mobile-message">
    <div class="content">
      <div class="main">
        <img src="@/assets/svg/Icon_Gradient.svg" />
        <h4>Want the best experience?</h4>
        <p>Seems like you are running the IC Robotics editor on a mobile device</p>
        <p>For optimized experience - run the editor from a desktop device</p>
      </div>
      <div class="bottom">
        <!-- <span class="text-xs text-muted">continue anyway</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.mobile-message {
  .content {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    .main {
      width: 75%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      img {
        width: 50px;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
